    const button = document.querySelector('.associates-load-more span');
    const associatesItems = document.querySelectorAll('.associates-items .associates-item');
    button?.addEventListener('click', () => {
        associatesItems.forEach( associatesItem => {
            if ( associatesItem.classList.contains('reveal') ) {
                associatesItem.classList.remove('reveal');
                button.innerText = 'LAAD MEER';
            } else {
                button.innerText = 'LAAD MINDER';
                associatesItem.classList.add('reveal');
            }
        });
    });